module.exports = __webpack_public_path__ + "static/flags/FJ-3d3ffdf28e1bb506f853bad22e7b8133.gif";